/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePresentation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2v20h16V7.586L14.414 2zm2 18V4h7v5h5v11zM16.586 7H15V5.414zM8.5 14.5a3.5 3.5 0 0 1 3-3.465v6.93a3.5 3.5 0 0 1-3-3.465zm4-.5v-2.965A3.503 3.503 0 0 1 15.465 14zm.707 1h2.258a3.483 3.483 0 0 1-.662 1.596zm-.707.707 1.596 1.596a3.483 3.483 0 0 1-1.596.662zM12 10a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFilePresentation as FilePresentation };
